import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";

import Footer from "../../components/common/Footer";
import CategoryCard from "../../components/Gallery/CategoryCard";
import AdminNavbar from "../AdminNavbar";
import { db } from "../../firebase/firebase";

import "../../assets/css/gallery.css";

function Gallery() {

    const [galleries, setGalleries] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        loadGalleryCategories();

    }, []);

    const loadGalleryCategories = async () => {

        try {

            const snapshot = await getDocs(
                collection(db, "gallery_categories")
            );

            const data = [];

            snapshot.forEach((doc) => {

                const category = doc.data();

                data.push({

                    id: doc.id,
                    title: category.title,
                    image: category.coverImage,
                    path: `/gallery/${encodeURIComponent(category.title)}`

                });

            });

            setGalleries(data);

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    };

    return (

        <div className="customer-gallery-page">

            <AdminNavbar />

            {/* =========================================================
                            PREMIUM HERO
            ========================================================= */}

            <section className="gallery-hero">

    <div className="gallery-hero-overlay"></div>

    <div className="gallery-hero-content">

        <span className="gallery-small-title">
            STORY LINE STUDIOS
        </span>

        <h1>
            Capturing Life's
            <span> Beautiful Stories</span>
        </h1>

        <p>
            Every photograph is more than an image.
            It is an emotion preserved forever,
            crafted with elegance, creativity,
            and cinematic excellence.
        </p>

        <div className="gallery-hero-buttons">

            <a
                href="#gallerySection"
                className="gallery-primary-btn"
            >
                Explore Collection
            </a>

        </div>

    </div>

    <div className="customer-gallery-scroll">

        <span></span>

    </div>

</section>

            {/* =========================================================
                            INTRO
            ========================================================= */}

            <section
    id="gallerySection"
    className="gallery-introduction"
>

    <div className="gallery-heading">

        <span>OUR PORTFOLIO</span>

        <h2>Luxury Photography Collections</h2>

        <div className="gallery-heading-line"></div>

        <p>
            Every collection tells a different story.
            Weddings, engagements, baby shoots,
            portraits and celebrations captured
            with timeless elegance.
        </p>

    </div>

</section>
            {/* =========================================================
                            CATEGORY GRID
            ========================================================= */}

            <section className="gallery-category-section">

                {

                    loading ?

                        (

                            <div className="gallery-loading">

                                <div className="gallery-loader"></div>

                                <h2>

                                    Loading Collections...

                                </h2>

                            </div>

                        )

                        :

                        galleries.length === 0 ?

                            (

                                <div className="gallery-empty">

                                    <h2>

                                        No Gallery Available

                                    </h2>

                                    <p>

                                        Gallery categories will appear here.

                                    </p>

                                </div>

                            )

                            :

                            (

                                <div className="gallery-grid">

                                    {

                                        galleries.map((gallery) => (

                                            <CategoryCard

                                                key={gallery.id}

                                                title={gallery.title}

                                                image={gallery.image}

                                                path={gallery.path}

                                            />

                                        ))

                                    }

                                </div>

                            )

                }

            </section>

            {/* =========================================================
                            QUOTE SECTION
            ========================================================= */}

            <section className="gallery-quote-section">

                <div className="gallery-quote">

                    <span>

                        "Photography is the art of making memories
                        unforgettable."

                    </span>

                    <h3>

                        Story Line Studios

                    </h3>

                </div>

            </section>

            <Footer />

        </div>

    );

}

export default Gallery;